'use strict';

angular.module('mean.options').factory('optionSaveService', ['$filter', 'toaster', 'Options',
    function($filter, toaster, Options) {
        //provide a bid id and a project id.  Function will
        //find an option with that bid id.  if too many options
        //are found it will return true meaning there is a problem.
        //if it finds the option, it will update the project
        //id and save.
        var updateProjectIdFromBidId = function(bid_id, project_id) {
            Options.query({'bid_id': bid_id}, function(options) {
                if(options.length === 0) {
                    toaster.pop('warning', 'No Options Found',
                        'Could not find an Option for this Bid.');
                } else if(options.length === 1) {
                    options[0].project_id = project_id;
                    options[0].$update(function(success) {
                        console.log('option found....updating project_id');
                    }, function(error) {
                        toaster.pop('error', 'Updating Bid Option', 
                            'Could not update the project_id. Contact Admin');
                        return true;
                    });
                } else {
                    toaster.pop('error', 'Too Many Options Found',
                        'Contact Admin.  Cannot continue...');
                    return true;
                }
            });

            return false;
        };

        return {
            updateProjectIdFromBidId: updateProjectIdFromBidId
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/options/public/services/option-save-service.js